export default "__VITE_PUBLIC_ASSET__5833c197__"